import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './assets/media/TongdyB@2x-8.png';
import _imports_1 from './assets/media/TongdyW@2x-8.png';

const _withScopeId = n => (_pushScopeId("data-v-82f22a4c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "logoview row-left"
};
const _hoisted_2 = {
  key: 0,
  class: "headlogo",
  alt: "logo",
  src: _imports_0
};
const _hoisted_3 = {
  key: 1,
  class: "headlogo",
  alt: "logo",
  src: _imports_1
};
const _hoisted_4 = {
  class: "mainmenu row-rigth"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 中文 ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" English ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Download = _resolveComponent("Download");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_progress = _resolveComponent("el-progress");

  const _component_CloseBold = _resolveComponent("CloseBold");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_popover = _resolveComponent("el-popover");

  const _component_el_switch = _resolveComponent("el-switch");

  const _component_el_menu_item = _resolveComponent("el-menu-item");

  const _component_el_sub_menu = _resolveComponent("el-sub-menu");

  const _component_el_menu = _resolveComponent("el-menu");

  const _component_el_header = _resolveComponent("el-header");

  const _component_router_view = _resolveComponent("router-view");

  const _component_el_main = _resolveComponent("el-main");

  const _component_el_container = _resolveComponent("el-container");

  const _component_el_config_provider = _resolveComponent("el-config-provider");

  return _openBlock(), _createBlock(_component_el_config_provider, {
    locale: _ctx.$i18n.locale == 'zh' ? _ctx.elloczh : _ctx.ellocen
  }, {
    default: _withCtx(() => [_createVNode(_component_el_container, null, {
      default: _withCtx(() => [_createVNode(_component_el_header, {
        class: _normalizeClass(_ctx.$store.state.isDark ? 'headbar headbar-dark' : 'headbar headbar-light')
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [!_ctx.$store.state.isDark ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true), _ctx.$store.state.isDark ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_row, {
          gutter: 0,
          justify: "end",
          align: "middle"
        }, {
          default: _withCtx(() => [_ctx.$store.state.progressList.length > 0 ? (_openBlock(), _createBlock(_component_el_popover, {
            key: 0,
            visible: _ctx.$store.state.downloadListVisible,
            "onUpdate:visible": _cache[1] || (_cache[1] = $event => _ctx.$store.state.downloadListVisible = $event),
            placement: "bottom",
            width: 400
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_button, {
              type: "success",
              onClick: _cache[0] || (_cache[0] = $event => _ctx.$store.state.downloadListVisible = !_ctx.$store.state.downloadListVisible)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Download)]),
                _: 1
              })]),
              _: 1
            })]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.progressList, p => {
              return _openBlock(), _createBlock(_component_el_row, {
                key: p.hash,
                gutter: 20
              }, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 8
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(p.name), 1)]),
                  _: 2
                }, 1024), _createVNode(_component_el_col, {
                  span: 13
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_progress, {
                    "text-inside": true,
                    "stroke-width": 22,
                    percentage: p.p,
                    color: _ctx.colors,
                    status: "warning"
                  }, null, 8, ["percentage", "color"])]),
                  _: 2
                }, 1024), _createVNode(_component_el_col, {
                  span: 2
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_button, {
                    size: "small",
                    circle: "",
                    onClick: $event => _ctx.cancelDL(_ctx.$store, p.hash)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_component_CloseBold)]),
                      _: 1
                    })]),
                    _: 2
                  }, 1032, ["onClick"])]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          }, 8, ["visible"])) : _createCommentVNode("", true), _createVNode(_component_el_switch, {
            modelValue: _ctx.$store.state.isDark,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.$store.state.isDark = $event),
            class: "mt-2",
            style: {
              "margin-left": "8px",
              "margin-right": "8px"
            },
            "inline-prompt": "",
            "active-color": "#181818",
            "inactive-color": "#B0C4DE",
            "active-icon": "Moon",
            "inactive-icon": "Sunny",
            "before-change": _ctx.beforeChange
          }, null, 8, ["modelValue", "before-change"]), _createVNode(_component_el_menu, {
            class: "flexEnd",
            "default-active": _ctx.$i18n.locale,
            mode: "horizontal",
            "background-color": _ctx.$store.state.isDark ? '#545c64' : 'rgb(213, 255, 241)',
            "text-color": _ctx.$store.state.isDark ? '#E5EAF3' : '#000',
            "active-text-color": _ctx.$store.state.isDark ? '#fff' : '#204472',
            ellipsis: false,
            onSelect: _ctx.settinghandleSelect
          }, {
            default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
              class: "menubutton row-rigth",
              index: "lang"
            }, {
              title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("loc")), 1)]),
              default: _withCtx(() => [_createVNode(_component_el_menu_item, {
                index: "zh-cn"
              }, {
                default: _withCtx(() => [_hoisted_5]),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "en"
              }, {
                default: _withCtx(() => [_hoisted_6]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["default-active", "background-color", "text-color", "active-text-color", "onSelect"])]),
          _: 1
        })])]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_main, null, {
          default: _withCtx(() => [_ctx.isRouterAlive ? (_openBlock(), _createBlock(_component_router_view, {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["locale"]);
}